<template>
  <a-menu
    class="ehf-menu"
    mode="inline"
    :selectedKeys="selectedKeys"
    v-model:openKeys="openKeys"
    :inline-collapsed="collapsed"
    @click="(e) => changeSelected(e)"
  >
    <menu-box v-for="item in menuList" :key="item.id" :item="item">
      <!-- 插槽：目录内容左侧的dom -->
      <template #left="slotProps">
        <slot name="left" v-bind="slotProps"></slot>
      </template>
      <!-- 插槽：目录内容右侧的dom -->
      <template #right="slotProps">
        <slot name="right" v-bind="slotProps"></slot>
      </template>
    </menu-box>
  </a-menu>
</template>

<script>
  export default {
    name: 'EhfMenu',
  }
</script>

<script setup>
  import { onMounted, toRefs, watch, ref } from 'vue'
  const emit = defineEmits(['changeSelected', 'changeOpenKeys'])
  const props = defineProps({
    // 选中项
    selectedKeys: {
      type: Array,
      default() {
        return []
      },
    },
    // 初始化展开项
    defaultOpenKeys: {
      type: Array,
      default() {
        return []
      },
    },
    // 数据,目前懒加载是menuList每一项添加字段expandshow实现，父级展开，子级展示
    menuList: {
      type: Array,
      default() {
        return []
      },
    },
    //是否收起
    collapsed: {
      type: Boolean,
      default: false,
    },
  })
  const { selectedKeys, defaultOpenKeys, menuList, collapsed } = toRefs(props)
  const openKeys = ref([])

  watch(defaultOpenKeys, (val) => {
    // 监听初始值目录项
    openKeys.value = val
  })
  watch(openKeys, (val) => {
    // 监听展开目录项
    emit('changeOpenKeys', val)
  })
  watch(menuList, (val) => {
    // 监听展开目录项
    console.log('menuList', val)
  })

  //触发选中项修改
  const changeSelected = (e) => {
    emit('changeSelected', e)
  }

  onMounted(() => {})
</script>
